import CountUp from "react-countup";
import { useInView } from "framer-motion";
import { useRef } from "react";

const metrics = [
  { value: 2.1, suffix: "M+", label: "Endpoints Secured Across Deployments", decimals: 1 },
  { value: 50, suffix: "+", label: "Full-Cycle PoCs & PoVs Delivered", decimals: 0 },
  { value: 50, suffix: "%", label: "Reduction in Incident Response Time", decimals: 0 },
  { value: 45, suffix: "%", label: "Reduction in Endpoint-Based Attacks", decimals: 0 },
  { value: 450, suffix: "K+", label: "Endpoints in Single Largest Deployment", decimals: 0 },
  { value: 30, suffix: "+", label: "Large Enterprise Implementations", decimals: 0 },
  { value: 25, suffix: "+", label: "Security Professionals Trained", decimals: 0 },
  { value: 5, suffix: "+", label: "Years in Enterprise Cybersecurity", decimals: 0 },
];

function MetricCounter({ value, suffix, label, decimals }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <div ref={ref} className="text-center p-6" data-testid={`metric-${label.slice(0, 15).toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="stat-number text-4xl sm:text-5xl text-[#0F172A]">
        {isInView ? <CountUp end={value} duration={2.5} decimals={decimals} /> : "0"}
        <span className="text-[#06B6D4]">{suffix}</span>
      </div>
      <p className="text-sm text-[#6B7280] mt-2 font-medium max-w-[180px] mx-auto">{label}</p>
    </div>
  );
}

export default function Impact() {
  return (
    <section id="impact" className="py-20 md:py-32 bg-gradient-to-b from-[#F9FAFB] to-[#F1F5F9]" data-testid="impact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">Results</span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-bold tracking-tight text-[#111827] mt-3">
            By the Numbers
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {metrics.map((m) => (
            <MetricCounter key={m.label} {...m} />
          ))}
        </div>

        <p className="text-center text-sm text-[#6B7280] italic mt-10" data-testid="impact-note">
          Detailed client references and case studies available upon request or in the downloadable CV.
        </p>
      </div>
    </section>
  );
}
